<template>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--分类名称-->
      <el-form-item label="角色名称" prop="role_name" :label-width="formLabelWidth">
        <el-input v-model="formData.role_name" autocomplete="off" placeholder="请输入角色名称"></el-input>
      </el-form-item>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import RoleApi from '@/api/study/role.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        /*角色名称*/
        role_name: '',
      },
      /*验证规则*/
      formRules: {
        role_name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
      },
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      }
    };
  },
  props: {
    open_add: Boolean,
    selectModel: Object
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    //监听选中
    handleCheckChange(data, checked) {
        this.form.category_ids = checked.checkedKeys.concat(checked.halfCheckedKeys);
    },
    /*添加*/
    onSubmit() {
      let self = this;
      let params = this.formData;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RoleApi.add(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/role/part/Add.vue